module.exports = __webpack_public_path__ + "static/media/analise.01829882.svg";